import {
  combineReducers,
  createSlice,
  createAction as factoryCreateAction,
  createReducer,
  createAsyncThunk
} from '@reduxjs/toolkit'

import { persistReducer } from './redux.Interface.Common'

import {
  GlobalFeatureNameSpaceNotary,
  CommonActionSubTypeNotary
} from './globalNotary'

const createAction = (featureNameSpace, actionSubType) => {
  return factoryCreateAction(featureNameSpace + '/' + actionSubType)
}

export {
  createAction,
  createReducer,
  createAsyncThunk,
  combineReducers,
  createSlice,
  GlobalFeatureNameSpaceNotary,
  CommonActionSubTypeNotary,
  persistReducer
}
